/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyKip = createReactComponent("currency-kip", "IconCurrencyKip", [
  ["path", { d: "M6 12h12", key: "svg-0" }],
  ["path", { d: "M9 5v14", key: "svg-1" }],
  ["path", { d: "M16 19a7 7 0 0 0 -7 -7a7 7 0 0 0 7 -7", key: "svg-2" }]
]);

export { IconCurrencyKip as default };
//# sourceMappingURL=IconCurrencyKip.js.map
